import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ModalInfoTextV2 } from '../../../components/common/ModalInfoTextV2';
import { imgTema6 } from '../../../assets/tema6';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	win: 14,
};

const stepThree = {

}

export const Theme6SubtopicFiveActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema6.activities.subtema5], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 6 sub 5 act 1");
			ObserverEmitter.emit(EVENTS.tema6.topic5.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub05.sub5_act1_a01)
	})

	ObserverEmitter.on(EVENTS.tema6.topic4.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 3].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema6.topic5.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Beneficios de Spin by OXXO" />
					<DialogBarNew
						dialog={`¡Veamos otro tema muy relevante! Spin by OXXO.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 5. Spin by OXXO"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub05.sub5_act1_a02)
							ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "move_close_desk");
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Spin es un nuevo medio de pago, funciona como una tarjeta de débito y la puedes usar en la APP, ¡veamos los beneficios!`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "move_client_1");
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<ModalInfoTextV2
						title="Beneficio 1:"
						description={`Programa de referidos: Invita a un amigo a través del enlace o código y ambos obtienen una recompensa.`}
						url={imgTema6.WhiteCard1}
						callback={() => {
							setUiToShow(steps.dialogFour);
						}}
					>
					</ModalInfoTextV2>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<ModalInfoTextV2
						title="Beneficio 2:"
						description={`Con tu teléfono o usando el código QR puedes mandar, recibir y solicitar dinero realizando transferencias con facilidad.`}
						url={imgTema6.WhiteCard2}
						callback={() => {
							setUiToShow(steps.dialogFive);
						}}
					>
					</ModalInfoTextV2>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<ModalInfoTextV2
						title="Beneficio 3:"
						description={`Gana "Puntos Premia" al usar tu tarjeta, los puntos pueden ser canjeados por productos en cualquier Tienda OXXO.`}
						url={imgTema6.WhiteCard3}
						callback={() => {
							setUiToShow(steps.dialogSix);
						}}
					>
					</ModalInfoTextV2>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<ModalInfoTextV2
						title="Beneficio 4:"
						description={`Acude a Tiendas OXXO o cajeros bancarios (ATM) para "Retirar Dinero" siempre que lo necesites.`}
						url={imgTema6.WhiteCard4}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "move_desk");
							setUiToShow(steps.win);
						}}
					>
					</ModalInfoTextV2>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal="Has completado otra actividad con éxito. Sigue así, ¡tu esfuerzo y dedicación son admirables!"
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema6.activities.subtema5
								})
							);
							navigator("/home6/tema6/subtema5/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}